import { useEffect, useState } from "react";

const Report = () => {
  useEffect(() => {
    location.replace(
      "https://open-res.biogeom.com/2025/geoflowv3/GeoFlow_V3_report_1117.pdf"
    );
  }, []);
  return <></>;
};

export default Report;
